import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Button from '../../Components/Button';
import InputManager from '../../Components/InputManager';
import FormManager from '../../Components/FormManager';
import { validateEmail, validateMobile } from '../../helpers/helper';

import { fetchCourseSyllabus } from '../../actions/course';
import { acitavteNotification } from '../../actions/Notification';
import { getCourseId } from '../../selectors/course';

class DownloadForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };

    this.formRef = React.createRef();
  }

  validateName = val => val.trim().length < 3;
  validateEmail = val => !validateEmail(val.trim());
  validatePhone = val => !validateMobile(val.trim());
  validateText = val => val.trim().length <= 0;

  toggleLoading = () => {
    this.setState(prevState => ({ isLoading: !prevState.isLoading }));
  };

  onSubmit = async (data, resetForm) => {
    try {
      const { courseId } = this.props;

      this.toggleLoading();
      await this.props.fetchCourseSyllabus({
        ...data,
        course_id: courseId
      });
      this.toggleLoading();
      this.onFetchComplete(true);
    } catch (err) {
      this.toggleLoading();
      this.onFetchComplete(false);
    }
  };

  onFetchComplete = (success = false) => {
    const { toggleForm } = this.props;

    if (!success) {
      this.props.acitavteNotification('Error', 'Oops!!,  Something went wrong');
    } else {
      this.openBroucherLink();
      this.clearForm();
      toggleForm();
    }
  };

  clearForm = () => {
    const { resetForm } = this.formRef.current;
    if (typeof resetForm === 'function') {
      resetForm();
    }
  };

  openBroucherLink = () => {
    const { broucherUrl } = this.props;
    const aTag = document.createElement('a');
    aTag.setAttribute('href', broucherUrl);
    aTag.setAttribute('download', 'image');
    aTag.setAttribute('target', '_');
    aTag.click();
  };

  render() {
    const { toggleForm } = this.props;
    const { isLoading } = this.state;
    return (
      <section className="live-classes-form-conatiner">
        <button onClick={toggleForm} className="live-classes-form-icon-box">
          <i className="fas fa-times"></i>
        </button>

        <p className="live-classes-form-title">Download our syllabus</p>
        <span className="live-classes-form-description">
          Fill up the form to receive more information about our career changing
          courses
        </span>

        <FormManager
          ref={this.formRef}
          className="live-classes-form"
          onSubmit={this.onSubmit}>
          <InputManager
            primary
            id="name"
            placeholder="Name"
            validate={this.validateName}
            required={true}
            emptyText="Name is required"
            invalidText="Name must be atleast 3 characters"
          />

          <InputManager
            primary
            id="email"
            placeholder="Email"
            validate={this.validateEmail}
            required={true}
            emptyText="Email is required"
            invalidText="Invalid email address"
          />

          <InputManager
            primary
            id="phone"
            placeholder="Phone Number"
            validate={this.validatePhone}
            required={true}
            emptyText="Phone number is required"
            invalidText="Invalid phone number"
          />

          <InputManager
            primary
            id="city"
            placeholder="City"
            validate={this.validateText}
            required={true}
            emptyText="City is required"
            invalidText="Invalid city name"
          />

          <Button
            className="live-classes-form-btn"
            loading={isLoading}
            type="submit"
            secondary
            text="DOWNLOAD"
          />
        </FormManager>
      </section>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCourseSyllabus,
      acitavteNotification
    },
    dispatch
  );

const mapStateToProps = (store, props) => {
  return {
    courseId: getCourseId(store, props)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DownloadForm);



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/DownloadForm.js